/**
 * Uma opção do funil de filtro de coluna (TabelaExcel e PainelTabela).
 *
 * É um BOTÃO com a caixinha só desenhando o estado. Antes era <label> com
 * preventDefault no clique: clicar em cima da caixinha fazia o navegador
 * desfazer a marcação DEPOIS que o React já tinha desenhado o estado novo, e
 * a opção ficava marcada na tela embora o filtro a tivesse tirado (05/11).
 */
import React from "react";

import { FunilItem } from "./styles";

export default function OpcaoDoFunil({ marcada, onAlternar, children }) {
  return (
    <FunilItem as="button" type="button" role="menuitemcheckbox" aria-checked={marcada} onClick={onAlternar}>
      <input type="checkbox" checked={marcada} readOnly tabIndex={-1} aria-hidden="true" />
      {children}
    </FunilItem>
  );
}
